module.exports = __webpack_public_path__ + "static/media/12.a708bbf7.mp3";